__turbopack_context__.v({
  "ant-select": "object-portal-props-module__JQPbTa__ant-select",
  "ant-select-dropdown": "object-portal-props-module__JQPbTa__ant-select-dropdown",
  "ant-select-item": "object-portal-props-module__JQPbTa__ant-select-item",
  "ant-select-item-option-active": "object-portal-props-module__JQPbTa__ant-select-item-option-active",
  "ant-select-item-option-content": "object-portal-props-module__JQPbTa__ant-select-item-option-content",
  "ant-select-item-option-selected": "object-portal-props-module__JQPbTa__ant-select-item-option-selected",
  "ant-select-selection-item": "object-portal-props-module__JQPbTa__ant-select-selection-item",
  "ant-select-selector": "object-portal-props-module__JQPbTa__ant-select-selector",
  "ant-space": "object-portal-props-module__JQPbTa__ant-space",
  "ant-typography": "object-portal-props-module__JQPbTa__ant-typography",
  "cameraBoundsRow": "object-portal-props-module__JQPbTa__cameraBoundsRow",
  "cameraBoundsRowSmall": "object-portal-props-module__JQPbTa__cameraBoundsRowSmall",
  "cameraSettingsRow": "object-portal-props-module__JQPbTa__cameraSettingsRow",
  "castShadowContainer": "object-portal-props-module__JQPbTa__castShadowContainer",
  "colorPickerContainer": "object-portal-props-module__JQPbTa__colorPickerContainer",
  "container": "object-portal-props-module__JQPbTa__container",
  "darkTheme": "object-portal-props-module__JQPbTa__darkTheme",
  "inputContainer": "object-portal-props-module__JQPbTa__inputContainer",
  "inputGroup": "object-portal-props-module__JQPbTa__inputGroup",
  "inputLabel": "object-portal-props-module__JQPbTa__inputLabel",
  "inputNumber": "object-portal-props-module__JQPbTa__inputNumber",
  "inputNumberSmall": "object-portal-props-module__JQPbTa__inputNumberSmall",
  "inputRow": "object-portal-props-module__JQPbTa__inputRow",
  "portalSelect": "object-portal-props-module__JQPbTa__portalSelect",
  "shadowCameraContent": "object-portal-props-module__JQPbTa__shadowCameraContent",
  "shadowContent": "object-portal-props-module__JQPbTa__shadowContent",
});
